export type OrganizationMedicalProfileCollaborator = {
    medicalProfileCollaboratorId: string;
    medicalProfileId: string;
    careTeamMemberId: string | undefined;
    lastProfileViewedDateTime: string | null;
    collaboratorOrganizationId: string;
};

export type UserMedicalProfileCollaborator = {
    medicalProfileCollaboratorId: string;
    medicalProfileId: string;
    careTeamMemberId: string | undefined;
    lastProfileViewedDateTime: string | null;
    collaboratorUserId: string;
};

export type MedicalProfileCollaborator = OrganizationMedicalProfileCollaborator | UserMedicalProfileCollaborator;

export const isOrganizationMedicalProfileCollaborator = (
    collaborator: MedicalProfileCollaborator,
): collaborator is OrganizationMedicalProfileCollaborator => 'collaboratorOrganizationId' in collaborator;

export const isUserMedicalProfileCollaborator = (
    collaborator: MedicalProfileCollaborator,
): collaborator is UserMedicalProfileCollaborator => 'collaboratorUserId' in collaborator;
